import request, { retryRequest } from '@/utils/request'
import * as Cart from '@/interfaces/cart'
import { AxiosPromise } from 'axios'

const path = '/eco'

export function addToCart (data: Cart.IAddToCartRequest): AxiosPromise<Cart.IAddToCartResponse> {
  return request({
    url: `${path}/add_to_cart.php`,
    method: 'post',
    data
  })
}

export function getCartList (data: Cart.IGetCartListRequest): AxiosPromise<Cart.IGetCartListResponse> {
  return retryRequest({
    url: `${path}/get_cart_list.php`,
    method: 'post',
    data
  }, (response) => {
    try {
      if (response.data.flag !== 0 && response.data.flag !== 2) {
        return true
      } else {
        return false
      }
    } catch (error) {
      console.log(error)
      return true
    }
  })
}

export function updateCart (data: Cart.IUpdateCartRequest): AxiosPromise<Cart.IUpdateCartResponse> {
  return request({
    url: `${path}/update_cart.php`,
    method: 'post',
    data
  })
}

export function buyMoreCart (data: Cart.IBuyMoreCartRequest): AxiosPromise<Cart.IBuyMoreCartResponse> {
  return request({
    url: `${path}/buymore_cart.php`,
    method: 'post',
    data
  })
}
